import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-smiley',
  templateUrl: './smiley.component.html',
  styleUrls: ['./smiley.component.css'],
})
export class SmileyComponent implements OnInit {
  @Input() description: string;
  @Input() name: string;
  @Input() value: number;
  @Output() selectedValue = new EventEmitter<string>();
  @Input() invalidAnswer: boolean;

  radioErrors = ['r0-error', 'star-rating-error'];

  ngOnInit(): void {}

  onClick() {
    this.selectedValue.emit(this.description);
  }

  getSmileyClass() {
    switch (this.value) {
      case 0:
        return 'r0';
      case 1:
        return 'star-rating';
      case 2:
        return 'star-rating';
      case 3:
        return 'star-rating';
      case 4:
        return 'star-rating';
      case 5:
        return 'star-rating';
    }
  }

  getErrorClass() {
    const errorClass = this.radioErrors.find((radioClass) =>
      radioClass.includes(this.getSmileyClass()),
    );
    return this.invalidAnswer && errorClass;
  }
}
